import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { z } from 'zod';

import { defaultApi } from '../clients.js';

const getQuerySchema = z.object({
  excludeDeleted: z.boolean().optional(),
  excludeNotIntegrated: z.boolean().optional(),
});
const IntegrationType = z.enum(['two_way', 'one_way', 'virtual'] as const);

const IntegrationCategory = z.enum([
  'integrated',
  'publisher',
  'dsp',
  'ad_network',
  'ad_server',
  'dmp',
  'brand_safety',
  'web_analytics',
] as const);

const getResponseSchema = z.array(
  z.object({
    id: z.number(),
    platform: z.string(),
    label: z.string(),
    channels: z.array(z.string()),
    description: z.string(),
    category: IntegrationCategory,
    logo: z.string().or(z.null()),
    type: IntegrationType,
    isDeleted: z.boolean(),
    isIntegrated: z.boolean().or(z.null()),
    integrationsCount: z.number().or(z.null()),
    isOmni: z.union([z.boolean(), z.undefined()]),
  }),
);

export type PlatformsResponse = z.infer<typeof getResponseSchema>;
export type Platform = PlatformsResponse[number];

export const list = defaultApi.declareEndpoint({
  url: 'bff/v2/platforms/',
  method: 'GET',
  querySchema: getQuerySchema,
  responseSchema: getResponseSchema,
  snakeCaseQueryParams: true,
});

export const listQueryOptions = makeQueryOptions(list, {
  processResponse(data) {
    return data;
  },
});
